<ng-container>
  {{ element.accuracyInfo.text | translate }}
</ng-container>
